/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Backtest status
 */
export enum BacktestStatus {

    Pending = 'pending',

    Running = 'running',

    Paused = 'paused',

    Completed = 'completed',

    Failed = 'failed',

    Cancelled = 'cancelled'
}
